(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-hero"] && !Shopify.designMode) return;
  try {
    
  class AdHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ad-hero-slide'));
      if (this.slides.length < 2) return;
      this.dots = Array.from(this.querySelectorAll('.ad-hero-dot'));
      this.index = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 6000;
      this.autoplay = this.dataset.autoplay === 'true';

      const prev = this.querySelector('.ad-hero-nav--prev');
      const next = this.querySelector('.ad-hero-nav--next');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.start(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.start(); });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.start(); }));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          const slide = e.target.closest('.ad-hero-slide');
          const i = this.slides.indexOf(slide);
          if (i > -1) { this.stop(); this.go(i); }
        });
        this.addEventListener('shopify:block:deselect', () => this.start());
      }

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.start();
      }
    }

    go(i) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.slides.forEach((slide, si) => {
        const active = si === this.index;
        slide.classList.toggle('is-active', active);
        if (active) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
      });
      this.dots.forEach((dot, di) => dot.classList.toggle('is-active', di === this.index));
    }

    start() {
      if (!this.autoplay) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.speed);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    disconnectedCallback() { this.stop(); }
  }

  if (!customElements.get('ad-hero-slideshow')) {
    customElements.define('ad-hero-slideshow', AdHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = Array.from(this.querySelectorAll('predictive-search'));

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearches.some((search) => search.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
